export const isDeliveredStatus = (status) =>
  String(status || '').toLowerCase() === 'delivered'

export const revertDeliveryDisabledReason = (shipment, user) => {
  if (!isDeliveredStatus(shipment?.status)) return 'Not delivered'
  if (shipment?.can_revert_delivery === false) {
    return shipment.delivery_revert_blocked_reason || 'Revert is not available'
  }
  if (shipment?.can_revert_delivery === true) return ''
  const role = user?.role
  if (['System Admin', 'Admin', 'Accountant', 'Hub Admin'].includes(role)) return ''
  if (role === 'Agent' && Number(shipment?.delivery_revert_count || 0) >= 1) {
    return 'You can revert delivery only once for this shipment'
  }
  if (role === 'Agent') return ''
  return 'Revert is not available'
}

export const canRevertDelivery = (shipment, user) =>
  revertDeliveryDisabledReason(shipment, user) === ''
